<form [formGroup]="form" #singleInNgForm="ngForm">
    <div class="grid sm:grid-cols-4 gap-3 w-full">
        <ng-container>
            <div class="col-span-4">
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="col-span-4">
                        <div class="w-100 float-left">
                            <mat-radio-group
                                [formControlName]="'documentType'"
                                (change)="changeDocumentType($event)"
                                aria-label="Veldu tegund af skrá"
                                [disabled]="
                                    !lsrauthService.inRole(userDetails, userRoles.DOCUMENT_TEMPLATES) ||
                                    documentTemplatesDropDown?.length == 0
                                "
                            >
                                <mat-radio-button class="w-100 float-left pl-4" value="file">Notast við skrá</mat-radio-button>
                                <mat-radio-button class="w-100 float-left pl-4 mt-1" value="template">Notast við sniðmát</mat-radio-button>
                            </mat-radio-group>
                            <span class="separator-line block mt-[20px]"></span>
                        </div>
                    </div>
                    @if (form.get('documentType').value == 'file') {
                        <div class="col-span-4">
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="w-full">
                                    <mat-label>Hópur</mat-label>
                                    <mat-select [formControlName]="'group'" placeholder="Hópur">
                                        @for (group of groupsDropDown; track group) {
                                            <mat-option [value]="group.value"> {{ group.viewValue }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <ngx-dropzone
                                class="custom-dropzone"
                                [multiple]="false"
                                class="justify-center"
                                (change)="onSelect($event)"
                                [disabled]="this.form.disabled"
                            >
                                <ngx-dropzone-label>
                                    <div
                                        [ngClass]="{
                                            'validation-error-color': files?.length == 0 && submitted,
                                        }"
                                    >
                                        <h2>Veldu eða dragðu inn skjal</h2>
                                        <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                    </div>
                                </ngx-dropzone-label>
                                @for (f of files; track f) {
                                    <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                                        <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                    </ngx-dropzone-preview>
                                }
                            </ngx-dropzone>
                        </div>
                    }
                    @if (form.get('documentType').value == 'template') {
                        <div class="col-span-4 sm:col-span-2">
                            <mat-form-field class="w-full">
                                <mat-label>Sniðmát</mat-label>
                                <mat-select [formControlName]="'documentTemplateKey'" placeholder="Tegund">
                                    @for (template of documentTemplatesDropDown; track template) {
                                        <mat-option [value]="template.value"> {{ template.viewValue | translate }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-span-4 sm:col-span-2">
                            <mat-form-field class="w-full">
                                <mat-label>Hópur</mat-label>
                                <mat-select [formControlName]="'group'" placeholder="Hópur">
                                    @for (group of groupsDropDown; track group) {
                                        <mat-option [value]="group.value"> {{ group.viewValue }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-span-4 -mt-6">
                            <mat-checkbox formControlName="includeAdditionalDocument" class="ml-[10px] mb-2"
                                >Bæta við viðbótarskjali</mat-checkbox
                            >
                        </div>
                        @if (form.get('includeAdditionalDocument').value) {
                            <div class="col-span-4">
                                <ngx-dropzone
                                    class="custom-dropzone"
                                    [multiple]="false"
                                    class="justify-center"
                                    (change)="onSelect($event)"
                                    [disabled]="this.form.disabled"
                                >
                                    <ngx-dropzone-label>
                                        <div
                                            [ngClass]="{
                                                'validation-error-color': files?.length == 0 && submitted,
                                            }"
                                        >
                                            <h2>Veldu eða dragðu inn skjal</h2>
                                            <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                        </div>
                                    </ngx-dropzone-label>
                                    @for (f of files; track f) {
                                        <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                                            <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                        </ngx-dropzone-preview>
                                    }
                                </ngx-dropzone>
                            </div>
                        }
                        @if (showAdditionalInputs) {
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_payment_period_from' | translate }}</mat-label>
                                    <input
                                        class="date"
                                        formControlName="documentTemplatePaymentFromDate"
                                        matInput
                                        (click)="documentTemplatePaymentFromDate.open()"
                                        [matDatepicker]="documentTemplatePaymentFromDate"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="documentTemplatePaymentFromDate"></mat-datepicker-toggle>
                                    <mat-datepicker #documentTemplatePaymentFromDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_payment_period_to' | translate }}</mat-label>
                                    <input
                                        class="date"
                                        formControlName="documentTemplatePaymentToDate"
                                        matInput
                                        (click)="documentTemplatePaymentToDate.open()"
                                        [matDatepicker]="documentTemplatePaymentToDate"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="documentTemplatePaymentToDate"></mat-datepicker-toggle>
                                    <mat-datepicker #documentTemplatePaymentToDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_salary_period_from' | translate }}</mat-label>
                                    <input
                                        class="date"
                                        formControlName="documentTemplateSalaryFromDate"
                                        matInput
                                        (click)="documentTemplateSalaryFromDate.open()"
                                        [matDatepicker]="documentTemplateSalaryFromDate"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="documentTemplateSalaryFromDate"></mat-datepicker-toggle>
                                    <mat-datepicker #documentTemplateSalaryFromDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="w-full">
                                    <mat-label>{{ 'label_salary_period_to' | translate }}</mat-label>
                                    <input
                                        class="date"
                                        formControlName="documentTemplateSalaryToDate"
                                        matInput
                                        (click)="documentTemplateSalaryToDate.open()"
                                        [matDatepicker]="documentTemplateSalaryToDate"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="documentTemplateSalaryToDate"></mat-datepicker-toggle>
                                    <mat-datepicker #documentTemplateSalaryToDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4">
                                <mat-checkbox formControlName="documentTemplateLetterMail" class="ml-[10px] mb-2"
                                    >Senda í bréfpósti</mat-checkbox
                                >
                            </div>
                        }
                        <div class="col-span-4">
                            <span class="separator-line block mt-[20px] mb-[10px]"></span>
                        </div>
                    }
                </div>
            </div>
            <documents-add-general-info
                class="col-span-4"
                formControlName="generalInfo"
                [includeSystem]="false"
            ></documents-add-general-info>
        </ng-container>
    </div>
    <div class="flex items-center justify-end mt-[5px]">
        <button mat-stroked-button type="button" (click)="revertSingleDocAllChanges()" [disabled]="!formEnabled">
            {{ 'label_cancel' | translate }}
        </button>
        <button
            class="ml-4"
            (click)="confirmAndSave()"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            [disabled]="!formEnabled || !form.valid || !form.dirty || (form.get('documentType').value == 'file' && files?.length == 0)"
        >
            Skrá bunkavinnslu
        </button>
    </div>
</form>
